import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export type DeleteDraftPayload = {
    id: string;
};

export type DeleteDraftResponse = {
    status: number;
    data: boolean;
};

export const deleteDraft = async (payload: DeleteDraftPayload): Promise<boolean> => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");

    const { id } = payload;

    const { data } = await gatewayPageBuilder.delete<DeleteDraftResponse>(
        `page-builder/drafts/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data.data;
};
